module.exports = __webpack_public_path__ + "static/media/lic_estrat.672a52aa.svg";